import { FormControl, Stack, TextField, Typography } from '@mui/material'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { CustomObservabilityToolOptions } from 'components/status-checks/form/authentication/CustomObservabilityToolOptions'
import { ObservabilityToolHeaders } from 'components/status-checks/form/authentication/ObservabilityToolHeaders'
import { type StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'
import { useObservabilityToolAuthenticationContext } from 'context/status-checks/ObservabilityToolAuthenticationContext'

export const ObservabilityToolCustomAuthenticationDetails = () => {
  const { control } = useFormContext<StatusCheckFormValues>()
  const { isEdit } = useObservabilityToolAuthenticationContext()

  return (
    <>
      <CustomObservabilityToolOptions />
      <Stack spacing={2} sx={{ mt: 4 }}>
        <Typography variant="h6">Authentication</Typography>
        <FormControl>
          <Typography sx={{ mb: 2 }}>
            What URL should Gremlin use to authenticate this observability tool?
          </Typography>
          <Controller
            control={control}
            name="authenticationUrl"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                data-testid="custom-observability-tool-authentication-url-input"
                disabled={isEdit}
                error={Boolean(error)}
                helperText={error?.message}
                label="Authentication Endpoint"
                variant="outlined"
              />
            )}
          />
        </FormControl>
        <Typography>
          What are the authentication key and header values Gremlin should use
          to authenticate this observability tool?
        </Typography>
        <ObservabilityToolHeaders isCustomObservabilityTool />
      </Stack>
    </>
  )
}
